import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Enterprise1SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={17}
      height={17}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M16.656.81h-16v16h16v-16Z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#EDEDED"
        fillRule="evenodd"
        d="M15.748 8.46A7.416 7.416 0 0 0 3.303 3.484l1.02 1.1a5.916 5.916 0 0 1 9.927 3.97c.067 1.069.465 2.36 1.538 3.086l.84-1.242c-.52-.352-.827-1.083-.88-1.938ZM1.874 5.3a7.385 7.385 0 0 0-.93 4.085c.125 1.99.41 3.96.853 5.891l1.462-.335a35.155 35.155 0 0 1-.818-5.65 5.885 5.885 0 0 1 .741-3.257L1.874 5.3Zm10.712 3.66a4.152 4.152 0 0 0-8.288.518c.046.73.116 1.456.21 2.178l1.488-.196c-.09-.688-.157-1.38-.2-2.075a2.652 2.652 0 0 1 5.293-.33c.038.613.099 1.223.181 1.83l1.486-.202a23.775 23.775 0 0 1-.17-1.722Zm1.07 5.725a23.857 23.857 0 0 1-.623-2.384l-1.468.304c.164.797.367 1.584.607 2.36l1.485-.28Zm1.648 10.946-3.799.749a4.141 4.141 0 0 0 3.8-.749Zm-9.852-9.4a32.14 32.14 0 0 1-.648-2.742l1.473-.28a30.606 30.606 0 0 0 .655 2.744l-1.48.279Zm3.32-.625-.04-.13v-.003a29.989 29.989 0 0 1-1.135-6.504.75.75 0 0 1 1.497-.094c.132 2.1.495 4.172 1.078 6.178v.001l.08.273-1.48.279Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default Enterprise1SVG;
